import { IFeature } from "@proj-common/types"
import React from "react"

interface IFeatureCard extends IFeature {
    bgColor: string
}

export const FeatureCard = (props: IFeatureCard) => {
    const videoRef = React.useRef<HTMLVideoElement>(null)
    const [isPlaying, setIsPlaying] = React.useState(false)

    const handleMouseEnter = () => {
        if (videoRef.current) {
            const playPromise = videoRef.current.play()
            if (playPromise !== undefined) {
                playPromise.then(() => setIsPlaying(true)).catch(error => { })
            }
        }
    }

    const handleMouseLeave = () => {
        if (videoRef.current) {
            videoRef.current.pause()
            setIsPlaying(false)
        }
    }

    return (
        //  transform transition-transform delay-200 duration-200 scale-90 hover:scale-100
        <div className={`flex flex-col items-center w-full space-y-8 text-center font-display p-6 text-slate-900 ${props.bgColor} rounded-xl`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >

             <div className=" w-4/5 aspect-square relative">
                {props.posterPath && <img
                    src={props.posterPath}
                    alt="Poster"
                    className={`object-cover rounded-xl absolute top-0 left-0 w-full h-full ${isPlaying ? 'hidden' : ''}`}
                />}
                <video
                    ref={videoRef}
                    className={`object-cover rounded-xl  ${isPlaying ? '' : 'hidden'}`}
                    playsInline={true}
                    loop={true}
                    autoPlay={false}
                    muted={true}
                    poster={props.posterPath}
                >
                    <source src={props.videoPath} type="video/mp4" />
                </video>
            </div>
            <h4 className='flex items-end  md:text-4xl leading-normal min-h-20  align-bottom '>{props.title}</h4>
            <p className="text-base font-normal leading-relaxed  md:text-base">{props.content}</p>
        </div>
    )

}